import React, { FunctionComponent } from 'react'
import { Portal } from 'react-native-portalize'

import { noop } from 'lodash-es'
import styled, { useTheme } from 'styled-components/native'

import { GLOBAL_HEADER_HEIGHT } from '@lyrahealth-inc/shared-app-logic/src/features/header/constants'

import { GlobalHeaderProps, HeaderRow, OuterContainer, useHeaderContents } from './globalHeaderParts'
import { FloatingTabBar, FloatingTabBarTab } from '../../molecules/floatingTabBar/FloatingTabBar'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { GradientHeader } from '../gradientHeader/GradientHeader'

const WebBlurContainer = styled.View<{ theme: ThemeType }>({
  width: '100%',
  height: GLOBAL_HEADER_HEIGHT,
  position: 'sticky',
  top: 0,
  zIndex: 1,
  flexDirection: 'column',
  justifyContent: 'flex-end',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
})

export const GlobalHeader: FunctionComponent<GlobalHeaderProps> = (props) => {
  const { isScrolled, navItems, careNavigatorModal, renderBottomNavInPortal = false } = props
  const { breakpoints } = useTheme() as ThemeType
  const { headerContents, activeNavTab } = useHeaderContents(props)

  const floatingTabBar =
    navItems && !breakpoints.isMinWidthLaptop && activeNavTab ? (
      <FloatingTabBar
        testID={tID('GlobalHeaderFloatingTabBar')}
        tabs={navItems
          .filter((item) => item.condition?.() ?? true)
          .map(
            (item): FloatingTabBarTab => ({
              key: item.id,
              label: item.text,
              icon: (isFocused, iconColor) => item.floatingIcon?.(iconColor) ?? item.icon?.(isFocused) ?? null,
              onPress: item.onPressItem ?? noop,
              testID: tID(`GlobalHeaderFloatingTabBar-tab-${item.id}`),
            }),
          )}
        activeTabKey={activeNavTab.id}
      />
    ) : null

  return (
    <>
      {isScrolled ? (
        <WebBlurContainer testID={tID('WebBlurContainer')}>
          <GradientHeader />
          <HeaderRow testID={tID('HeaderRow')}>{headerContents}</HeaderRow>
        </WebBlurContainer>
      ) : (
        <OuterContainer topInset={0}>
          <HeaderRow>{headerContents}</HeaderRow>
        </OuterContainer>
      )}
      {careNavigatorModal}
      {renderBottomNavInPortal && floatingTabBar ? <Portal>{floatingTabBar}</Portal> : floatingTabBar}
    </>
  )
}

export type { GlobalHeaderProps }
